import { t } from '@/plugins/i18n'

export default {
  namespaced: true,
  state: {
    list: [
      { label: '帮助', name: 'help', check: true },
      {
        label: '插件安装',
        check: true,
        route: 'campaign',
        params: { name: 'plugin' }
      },
      {
        label: '订单管理',
        check: true,
        children: [
          { label: 'API同步订单', route: 'SyncOrder', plat: 'd2c' },
          { label: '我的订单', route: 'OrderList' },
          { label: '异常订单', route: 'AbnormalOrder' }
        ]
      },
      {
        label: '商品管理',
        check: true,
        children: [
          { label: '库存管理', route: 'stock' },
          { label: '组合商品管理', route: 'CombinedGoods' },
          { label: '同步商品', route: 'SyncProduct', plat: 'b2b' },
          { label: '关联商品库', route: 'AssociatedProductlib', plat: 'd2c' },
          { label: '我的收藏', route: 'CollectProduct' },
          { label: '购买过', route: 'AfterPurchase' },
          { label: '足迹', route: 'FootPrint' }
        ]
      },
      {
        label: '国际配送管理',
        check: true,
        plat: 'b2b',
        children: [
          { label: 'FBA补货计划', route: 'ReplenishmentList' },
          { label: '国际发货管理', route: 'ShippingList' },
          { label: '国际发货售后', route: 'AfterSale' }
        ]
      },
      {
        label: '资金管理',
        check: true,
        children: [
          { label: '资金明细', route: 'CustomerFund' },
          { label: '资金明细', route: 'StoreFund' }
        ]
      },
      // {
      //   label: 'OEM',
      //   check: true,
      //   children: [
      //     { label: 'OEM寻源', route: 'oemQuest' },
      //     { label: '寻源列表', route: 'SourcingOEM' },
      //     { label: 'OEM复购', route: 'ReorderOEM' }
      //   ]
      // },
      {
        label: '店铺管理',
        check: true,
        children: [
          { label: '店铺配置', route: 'setupShop' },
          { label: 'API/子账号配置', route: 'AuthorizedStore' }
          // { label: t('附加项管理'), route: 'AuthorizedStore' }
        ]
      },
      {
        label: '会员相关',
        check: true,
        children: [
          { label: '会员办理', route: 'VipLevel' },
          { label: '消息', route: 'Information' }
        ]
      }
    ]
  },
  mutations: {},
  local: {
    list: true
  }
}
